<template>
  <div class="d-flex" style="min-height: 45vw">
    <div class="content p-4 w-100">
      <h4 class="card-title mt-0">{{ title }}</h4>
      <div class="row download-data-histories-list">
        <v-table>
          <thead>
            <tr>
              <th>{{ i18n.global.t('pages.downloadData.outputDate') }}</th>
              <th class="text-center">{{ i18n.global.t('pages.downloadData.status') }}</th>
              <th>{{ i18n.global.t('pages.downloadData.user') }}</th>
              <th>{{ i18n.global.t('pages.downloadData.format') }}</th>
              <th>{{ i18n.global.t('pages.downloadData.fileName') }}</th>
              <th>{{ i18n.global.t('pages.downloadData.fileFormat') }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <template v-if="downloadDataHistoryItems?.length != 0">
              <template v-for="item in downloadDataHistoryItems" :key="item.id">
                <Row
                  :item="item"
                />
              </template>
            </template>
            <template v-else>
              <tr>
                <td colspan="9">
                  {{ i18n.global.t('pages.downloadData.messages.noData') }}
                </td>
              </tr>
            </template>
          </tbody>
        </v-table>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';
import getDownloadData from '@/types/responses/getDownloadData';
import Row from '@/components/DownloadDataHistoriesParts/DataRow.vue';
import { formatDate } from '@/services/functions';
import i18n from '@/lang/i18n';
import { getAccessCheckerInstance } from '@/router/accessChecker';
import { routingAuthorityNames } from '@/services/consts';

const title = i18n.global.t('pages.downloadData.title.downloadDataHistories')
const downloadDataHistoryItems = ref<getDownloadData[]>([]);

onMounted(() => {
  document.title = title
  getHistories();
});

function makeGetRequestParams() {
  let today = new Date();
  today.setMonth(today.getMonth() - 3);
  const params = {
    start: formatDate(today),
  };
  return params;
}

async function getHistories(){
  const params = makeGetRequestParams();
  const accessChecker = await getAccessCheckerInstance();
  const hasDownloadData = accessChecker.hasUserAccessTo(routingAuthorityNames.DownloadDataHistories);
  const hasCsvDataExport = accessChecker.hasUserAccessTo(routingAuthorityNames.CsvDataExport);

  const requests: Promise<getDownloadData[]>[] = [];
  if (hasDownloadData) {
    requests.push(Api().getDownloadDatas(params));
  }
  if (hasCsvDataExport) {
    requests.push(Api().getCsvDataExports(params));
  }

  const results = await Promise.all(requests);
  downloadDataHistoryItems.value = results.flat().sort((a, b) => {
    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
  });
}
</script>

<style>
.download-data-histories-list table th {
  background-color: #f8f9fa;
  position: sticky;
  top: 0;
}
</style>
